module.exports = __webpack_public_path__ + "cc27e2e37ba7f5ee652ae43769c51d2f.pdf";